import { register } from 'tmr/tmr/ngModuleRegistry'

import * as activeWorkstation from './workstation/workstation.active'
import * as antenna from './antenna/antenna'
import * as appData from './appData/appData'
import * as asn from './asn/asn'
import * as barcodeReader from './barcodeReader/barcodeReader'
import * as checklist from './checklist/checklist'
import * as checklistByUpc from './checklistByUpc/checklistByUpc'
import * as checklistByItem from './checklistByItem/checklistByItem'
import * as configuration from './configuration/configuration'
import * as conveyor from './conveyor/conveyor'
import * as conveyorPackageEvent from './conveyorPackageEvent/conveyorPackageEvent'
import * as conveyorPackageScanning from './conveyorPackageScanning/conveyorPackageScanning'
import * as deviceController from './deviceController/deviceController'
import * as eventLog from './eventLog/eventLog'
import * as hierarchy from './hierarchy/hierarchy'
import * as inventory from './inventory/inventory'
import * as inventoryItem from './inventoryItem/inventoryItem'
import * as item from './item/item'
import * as movement from './movement/movement'
import * as movementEncoding from './movement/movementEncoding'
import * as movementHelper from './movement/movementHelper'
import * as movementByUpcHelper from './movement/movementByUpcHelper'
import * as movementInbound from './movement/movementInbound'
import * as movementInventoryConfirmation from './movement/movementInventoryConfirmation'
import * as movementOutbound from './movement/movementOutbound'
import * as movementReturn from './movement/movementReturn'
import * as movementSale from './movement/movementSale'
import * as movementShippingInbound from './movement/movementShippingInbound'
import * as movementShippingOutbound from './movement/movementShippingOutbound'
import * as movementTransferToZone from './movement/movementTransferToZone'
import * as operationConfiguration from './operationConfiguration/operationConfiguration'
import * as parcel from './parcel/parcel'
import * as place from './place/place'
import * as printRequest from './printRequest/printRequest'
import * as printSession from './printSession/printSession'
import * as printer from './printer/printer'
import * as product from './product/product'
import * as productGroup from './productGroup/productGroup'
import * as productPrintSession from './product/product.printSession'
import * as productionLot from './productionLot/productionLot'
import * as productionLotPrintSession from './productionLot/productionLot.printSession'
import * as productionOrder from './productionOrder/productionOrder'
import * as productionOrderRow from './productionOrderRow/productionOrderRow'
import * as productionOrderRowPrintSession from './productionOrderRow/productionOrderRow.printSession'
import * as productionWorkflow from './productionWorkflow/productionWorkflow'
import * as rfidGate from './rfidGate/rfidGate'
import * as rfidReader from './rfidReader/rfidReader'
import * as role from './role/role'
import * as scanner from './scanner/scanner'
import * as session from './session/session'
import * as sessionItem from './sessionItem/sessionItem'
import * as sessionMovement from './sessionMovement/sessionMovement'
import * as shippingEntry from './shippingEntry/shippingEntry'
import * as shippingParcel from './shippingParcel/shippingParcel'
import * as shippingNotice from './shippingNotice/shippingNotice'
import * as stock from './stock/stock'
import * as transfer from './transfer/transfer'
import * as user from './user/user'
import * as userStorage from './user/user.storage'
import * as workstation from './workstation/workstation'
import * as workstationAntennas from './antenna/workstationAntennas'
import * as xspan from './xspan/xspan'
import * as zone from './zone/zone'
import * as alert from './alert/alert'
import * as cycleCount from './cycleCount/cycleCount'
import * as cycleCountItem from './cycleCountItem/cycleCountItem'
import * as shippingInbound from './shippingInbound/shippingInbound'
import * as shippingOutbound from './shippingOutbound/shippingOutbound'
import * as itemConfiguration from './itemConfiguration/itemConfiguration'

export default register(
  'tmr.core.resources',
  antenna,
  appData,
  workstationAntennas,
  asn,
  barcodeReader,
  checklist,
  checklistByUpc,
  checklistByItem,
  configuration,
  conveyor,
  conveyorPackageEvent,
  conveyorPackageScanning,
  deviceController,
  eventLog,
  hierarchy,
  inventory,
  inventoryItem,
  item,
  movement,
  movementHelper,
  movementByUpcHelper,
  movementEncoding,
  movementInbound,
  movementInventoryConfirmation,
  movementOutbound,
  movementReturn,
  movementSale,
  movementShippingInbound,
  movementShippingOutbound,
  movementTransferToZone,
  operationConfiguration,
  parcel,
  place,
  printer,
  printRequest,
  printSession,
  product,
  productGroup,
  productPrintSession,
  productionLot,
  productionLotPrintSession,
  productionOrder,
  productionOrderRow,
  productionOrderRowPrintSession,
  productionWorkflow,
  rfidGate,
  rfidReader,
  scanner,
  session,
  sessionItem,
  sessionMovement,
  shippingEntry,
  shippingParcel,
  shippingNotice,
  stock,
  role,
  transfer,
  user,
  userStorage,
  workstation,
  activeWorkstation,
  xspan,
  zone,
  alert,
  cycleCount,
  cycleCountItem,
  shippingInbound,
  shippingOutbound,
  itemConfiguration
)
